import React, { useState, useEffect } from 'react';
import styled, { css } from 'styled-components/macro';
import {
  H4,
  H5,
  SkeletonContainer,
  SkeletonHeading,
} from '@snsw/react-component-library';

const FeeComponent = styled.div`
  padding: 0.25rem 1rem;
  // box-shadow: 0px -1px 0px 0px #dee3e5 inset;
  ${(props) =>
    props.isTotal
      ? css`
          background: #dee3e5;
          padding: 1rem;
          box-shadow: 0px -1px 0px 0px #dee3e5 inset;
        `
      : ''}
  ${(props) =>
    props.isTitleContainer
      ? css`
          background: #dee3e5;
          margin-bottom: 1rem;
          padding: 1rem;
        `
      : ''}
  ${(props) =>
    props.isSummary
      ? css`
          background: #f4f7f9;
          margin-top: 1rem;
          padding: 1rem;
        `
      : ''}
  ${(props) =>
    props.isMainDescription
      ? css`
          margin: 1rem 0.25rem;
        `
      : ''}
`;

const Summary = styled.div`
  border: 1px solid #dee3e5;
  border-radius: 4px;
  padding: 1.25rem;
`;

const FeeBreakDown = styled.div`
  margin-bottom: 1.5em;
`;

const RowContainer = styled.div`
  display: inline-flex;
  width: 100%;
`;

const RowDescription = styled.div`
  flex: 1;
`;

const RowQuantity = styled.div`
  width: 80px;
`;

const RowValue = styled.div`
  min-width: 130px;
  text-align: end;
`;

const formatter = new Intl.NumberFormat('en-AU', {
  style: 'currency',
  currency: 'AUD',
});

const FeeRow = ({
  name,
  quantity,
  value,
  isTotal,
  isSummary,
  isTitleContainer,
  isMainDescription,
}) => (
  <FeeComponent
    isTotal={isTotal}
    isSummary={isSummary}
    isTitleContainer={isTitleContainer}
    isMainDescription={isMainDescription}
  >
    <RowContainer>
      <RowDescription>{name}</RowDescription>
      <RowQuantity>{quantity}</RowQuantity>
      <RowValue>{!isNaN(value) ? formatter.format(value) : value}</RowValue>
    </RowContainer>
  </FeeComponent>
);

const FeeSummary = ({
  isLoading,
  totalFeeAmount,
  feeComponents,
  title = 'Fee summary',
  feeDesctiption,
}) => {
  const [skeletonFees, setSkeletonFees] = useState([]);

  useEffect(() => {
    if (skeletonFees.length === 0 && feeComponents) {
      setSkeletonFees(feeComponents.map((m) => m.name));
    }
  }, [feeComponents, skeletonFees.length]);

  const skeletonLoader = (
    <SkeletonContainer>
      {feeComponents?.map((m) => (
        <FeeRow
          value={<SkeletonHeading level={5} noMargin />}
          name={<SkeletonHeading level={5} noMargin />}
          key={m}
        />
      ))}
      <FeeRow
        isSummary
        value={<SkeletonHeading level={5} noMargin />}
        name={<H5>Total due</H5>}
      />
    </SkeletonContainer>
  );

  const summaryElements = (
    <>
      <FeeRow name={feeDesctiption} isMainDescription={true} />
      {feeComponents
        ? feeComponents.map((feeComponent) => (
            <FeeRow
              value={feeComponent.value}
              name={<li>{feeComponent.feeName}</li>}
              key={feeComponent.feeName}
              quantity={feeComponent.quantity}
            />
          ))
        : null}
      <FeeRow isSummary value={totalFeeAmount} name={<H5>Total due</H5>} />
    </>
  );

  const titleElement = (
    <FeeBreakDown>
      <H4>{title}</H4>
    </FeeBreakDown>
  );

  const detailsTitleElements = (
    <FeeRow
      isTitleContainer
      value={<H5>Amount</H5>}
      quantity={<H5>Quantity</H5>}
      name={<H5>Description</H5>}
    />
  );

  return (
    <Summary>
      {isLoading ? (
        <>
          {titleElement}
          {detailsTitleElements}
          {skeletonLoader}
        </>
      ) : typeof feeComponents !== 'undefined' ? (
        <>
          {titleElement}
          {detailsTitleElements}
          {summaryElements}
        </>
      ) : (
        summaryElements
      )}
    </Summary>
  );
};

export default FeeSummary;
